module.exports = __webpack_public_path__ + "img/pure-ptfe-valva-seat.f239ba14.png";